import React, { Component } from 'react'
import ReactTextCollapse from 'react-text-collapse' 
import ArrowR from '@material-ui/icons/ArrowForward'
import { css } from '@emotion/core'
import Div from '../components/Div/Div.styles'
import ds from '../theme'
import { mq } from '../components/styles/Layout.styles'
import H4 from '../components/H4'
import H5 from '../components/H5'
import Paragraph from '../components/Paragraph'
import Subtitle from '../components/SubTitle2'

import { scrollAction } from '../components/styles/InternalPage.styles'

const TEXT_COLLAPSE_OPTIONS = { 
  collapse: false, 
  collapseText: '+ Mais detalhes', 
  expandText: '- Ocultar detalhes', 
  minHeight: 0, 
  maxHeight: 1160,
  marginTop: 54, 
  overflow: 'hidden !important',
  textStyle: { 
    color: '#f9fafa', 
    fontSize: '14px' ,
    lineHeight: 1.71,
    marginTop: '54px',
    textAlign: 'center',
    width: '100%',
    cursor: 'pointer'
  }
}

const ImportantLicence = ({
  licenceName,
  licenceDescription,
  licenceIso,
  licenceBenefits,
  benefitsDescription,
  benefitsDescriptionItem2,
  benefitsDescriptionItem3,
  benefitsDescriptionItem4,
  benefitsDescriptionItem5,
  benefitsDescriptionItem6,
  benefitsDescriptionItem7,
}) => {
  return (
    <div
      style={{
        padding: '50px 24px 24px 24px',
        backgroundColor: '#9013fe',
        border: 'solid 1px rgba(0, 0, 0, 0.12)',
        borderRadius: 12
      }}
      css={
        [css(
          mq({
            '&:not(:last-child)': {
              marginBottom: ds.space(3)
            } 
          })
        ),
        // item 
      ]
      }
    >
      <Div
        flexDirection='column'
        alignItems='center'
      >
        <H4
          selected
          on='onSurface'
          variant='highEmphasis'
          style={{
            letterSpacing: 0.25,
            marginBottom: 50,
            width: 296,
            textAlign: 'center',
            color: '#f9fafa'
          }}
        >
          {licenceName}
        </H4>
        <Div
          style={{
            width: 200,
            height: 60,
            borderRadius: 30,
            border: 'solid 1px #fff',
            justifyContent: 'center',
            marginBottom: 17
          }}
        >
          <Subtitle
            style={{
              fontSize: 14,
              fontWeight: 600,
              lineHeight: 1.5,
              letterSpacing: 2.38,
              textAlign: 'center',
              color: '#f9fafa',
              whiteSpace: 'pre-wrap'
            }}
          >
            {licenceIso}
          </Subtitle>
        </Div>
        <ReactTextCollapse
          options={TEXT_COLLAPSE_OPTIONS}
          css={scrollAction}
        >
          <Div 
            style={{
              width: 200,
              height: 1,
              borderBottom: 'solid 1px #e0e0e0',
              margin: '0 auto',
              marginTop: 20,
              marginBottom: 20
            }}
          />
          <Paragraph
            style={{
              fontSize: 14,
              lineHeight: 1.7,
              textAlign: 'center',
              color: '#f9fafa'
            }}
          >
            {licenceDescription}
          </Paragraph>
          <Div 
            style={{
              width: 200,
              height: 1,
              borderBottom: 'solid 1px #e0e0e0',
              margin: '0 auto',
              marginTop: 20,
              marginBottom: 20
            }}
          />
          <H5 
            style={{
              fontSize: 23.7,
              textAlign: 'center',
              fontWeight: 500,
              color: '#f9fafa',
              marginTop: 10,
              marginBottom: 24,
              whiteSpace: 'pre-wrap'
            }}>
            {licenceBenefits}
          </H5>
          <Div
            style={{
              display: '-webkit-box',
              marginBottom: 16
            }}
          >
            <ArrowR 
              style={{
                color: 'rgba(255, 255, 255, 0.54)'
              }}
            />
            <Paragraph
              style={{
                fontSize: 14,
                lineHeight: 1.7,
                textAlign: 'left',
                width: 240,
                marginLeft: 16,
                color: '#f9fafa'
              }}
            >
              {benefitsDescription}
            </Paragraph>
          </Div>
          <Div
            style={{
              display: '-webkit-box',
              marginBottom: 16
            }}
          >
            <ArrowR 
              style={{
                color: 'rgba(255, 255, 255, 0.54)'
              }}
            />
            <Paragraph
              style={{
                fontSize: 14,
                lineHeight: 1.7,
                textAlign: 'left',
                width: 240,
                marginLeft: 16,
                color: '#f9fafa'
              }}
            >
              {benefitsDescriptionItem2}
            </Paragraph>
          </Div>
          <Div
            style={{
              display: '-webkit-box',
              marginBottom: 16
            }}
          >
            <ArrowR 
              style={{
                color: 'rgba(255, 255, 255, 0.54)'
              }}
            />
            <Paragraph
              style={{
                fontSize: 14,
                lineHeight: 1.7,
                textAlign: 'left',
                width: 240,
                marginLeft: 16,
                color: '#f9fafa'
              }}
            >
              {benefitsDescriptionItem3}
            </Paragraph>
          </Div>
          <Div
            style={{
              display: '-webkit-box',
              marginBottom: 16
            }}
          >
            <ArrowR 
              style={{
                color: 'rgba(255, 255, 255, 0.54)'
              }}
            />
            <Paragraph
              style={{
                fontSize: 14,
                lineHeight: 1.7,
                textAlign: 'left',
                width: 240,
                marginLeft: 16,
                color: '#f9fafa'
              }}
            >
              {benefitsDescriptionItem4}
            </Paragraph>
          </Div>
          <Div
            style={{
              display: '-webkit-box',
              marginBottom: 16
            }}
          >
            <ArrowR 
              style={{
                color: 'rgba(255, 255, 255, 0.54)'
              }}
            />
            <Paragraph
              style={{
                fontSize: 14,
                lineHeight: 1.7,
                textAlign: 'left',
                width: 240,
                marginLeft: 16,
                color: '#f9fafa'
              }}
            >
              {benefitsDescriptionItem5}
            </Paragraph>
          </Div>
          <Div
            style={{
              display: '-webkit-box',
              marginBottom: 16
            }}
          >
            <ArrowR 
              style={{
                color: 'rgba(255, 255, 255, 0.54)'
              }}
            />
            <Paragraph
              style={{
                fontSize: 14,
                lineHeight: 1.7,
                textAlign: 'left',
                width: 240,
                marginLeft: 16,
                color: '#f9fafa'
              }}
            >
              {benefitsDescriptionItem6}
            </Paragraph>
          </Div>
          <Div
            style={{
              display: '-webkit-box',
            }}
          >
            <ArrowR 
              style={{
                color: 'rgba(255, 255, 255, 0.54)'
              }}
            />
            <Paragraph
              style={{
                fontSize: 14,
                lineHeight: 1.7,
                textAlign: 'left',
                width: 240,
                marginLeft: 16,
                color: '#f9fafa'
              }}
            >
              {benefitsDescriptionItem7}
            </Paragraph>
          </Div>
        </ReactTextCollapse>
      </Div>
    </div>
  )
}

class MelhorColocation extends Component {
  render () {
    return (
      <div>
        <ImportantLicence
          licenceName='Certificado'
          licenceIso={`Tier III Design Certification`}
          licenceDescription='Para entender de forma simples e direcionada os diferenciais que uma estrutura de Data
          Center oferece, a Uptime Institute criou a certificação Tier. Diferenciadas por níveis (I, II, III e
          IV), essa certificação analisa e constata a disponibilidade oferecida pelos padrões de
          redundância da empresa. É um selo de confiabilidade, qualidade e entrega.'
          licenceBenefits={`Benefícios para\n sua empresa`}
          benefitsDescription='Múltiplos caminhos de distribuição redundante servindo os ativos de TI;'
          benefitsDescriptionItem2='Equipamentos de TI dual-alimentados, compatíveis com a topologia de arquitetura
          local;'
          benefitsDescriptionItem3='Redundância dos componentes elétricos e de TI​, permitindo uma manutenção
          concorrente a qualquer momento, sem interrupção da operação;'
          benefitsDescriptionItem4='Cumprimento dos mais elevados padrões de funcionalidade e capacidade de
          infraestrutura (topologia);'
          benefitsDescriptionItem5='Disponibilidade de no mínimo 99,982% ao ano;'
          benefitsDescriptionItem6='Solicitação de estrutura que garanta 72 horas contra interrupção de energia - a
          infraestrutura da HostDime Brasil garante 240 horas.'
          benefitsDescriptionItem7='Alinhamento do projeto de infraestrutura à missão de negócios, garantindo que o
          investimento financeiro significativo produza o resultado desejado à organização e
          aos seus clientes.'
        />
      </div>
    )
  }
}

export default MelhorColocation